import dayjs from "dayjs";

export default {
  methods: {
    getEstimatedPickupDate() {
      const chosenLoad = this.$store.getters["load/getChosenLoad"];
      const pickupStop = chosenLoad?.stops?.find((stop) => stop.is_pickup);
      return pickupStop?.expected_date || null;
    },
    isPickupOutsideRateValidity(carrier) {
      const pickupDate = this.getEstimatedPickupDate();
      if (!pickupDate || !carrier?.expiration) {
        return false;
      }
      const expiration = dayjs(carrier.expiration);
      const pickup = dayjs(pickupDate);
      if (!expiration.isValid() || !pickup.isValid()) {
        return false;
      }
      return pickup.isAfter(expiration, "day");
    },
    isRateUnavailable(carrier) {
      return this.checkIfCarrierHasExpired(carrier) || this.isPickupOutsideRateValidity(carrier);
    },
    rateUnavailablePopover(carrier) {
      if (this.checkIfCarrierHasExpired(carrier)) {
        return this.$t("carriers.priceExpired");
      }
      if (this.isPickupOutsideRateValidity(carrier)) {
        const date = dayjs(carrier.expiration).format("MM-DD-YYYY");
        return {
          title: this.$t("carriers.pickupOutsideRateValidityTitle"),
          content: this.$t("carriers.pickupOutsideRateValidity", { date }),
        };
      }
      return "";
    },
  },
};
